var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.17,
    height: 23.26,
    viewBox: "0 0 24.17 23.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #703ac2;\n      }\n\n      .cls-2 {\n        fill: #383838;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3673",
    "data-name": "Group 3673"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16644",
    "data-name": "Path 16644",
    className: "cls-1",
    d: "M12.77,7.78v8.31a11.09,11.09,0,0,1,5.49,0V7.78A4.43,4.43,0,0,0,12.77,7.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16645",
    "data-name": "Path 16645",
    className: "cls-1",
    d: "M5.91,7.78v8.31a11.09,11.09,0,0,1,5.49,0V7.78A4.43,4.43,0,0,0,5.91,7.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16646",
    "data-name": "Path 16646",
    className: "cls-2",
    d: "M21.15,0H3A3,3,0,0,0,0,3V20.24a3,3,0,0,0,3,3H21.15a3,3,0,0,0,3-3h0V3A3,3,0,0,0,21.15,0ZM19.63,17.12a.66.66,0,0,1-.36.61.68.68,0,0,1-.7,0,6.27,6.27,0,0,0-3.05-.57,6.56,6.56,0,0,0-3,.54l-.11.07a.72.72,0,0,1-.32.08h0a.72.72,0,0,1-.32-.08l-.11-.07a6.56,6.56,0,0,0-3-.54,6.05,6.05,0,0,0-3.05.57.69.69,0,0,1-.95-.19.67.67,0,0,1-.11-.38V7.51a.67.67,0,0,1,.13-.41,5,5,0,0,1,4-1.65,5.85,5.85,0,0,0,6.86,0,5,5,0,0,1,4,1.65.68.68,0,0,1,.14.41Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInt);
export default __webpack_public_path__ + "static/media/INT.04ab714b7a3f33e5c2abb0ed65619ed2.svg";
export { ForwardRef as ReactComponent };